import { generatePath, useLoaderData, useLocation, useNavigate } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { SubscriptionCategory } from '../../../../../common/enums.js';
import { useGetServiceFeeSim } from '../../../../../common/hooks/useGetServiceFeeSim';
import { omaElisaForCompaniesMsg, orderSimMsg, t, voiceSubscriptionsMsg } from '../../../../../common/i18n';
import { getSubscriptionBreadcrumbName, getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils.js';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { OrderSim } from '../../../../../components/OrderSim/OrderSim.js';
import { SimType } from '../../../../../generated/api/models.js';
import { useAuth } from '../../../AuthProvider.js';
import type { MobileSubPostChangeRequestLoaderResponse } from '../../../../../common/loaders';

export const MobileSubOrderSimPath = () => {
  const { authenticatedUser } = useAuth();
  const { companyInfo, hasPendingActions, subscription } = useLoaderData() as MobileSubPostChangeRequestLoaderResponse;
  const getServiceFeeSim = useGetServiceFeeSim();
  const { search } = useLocation();
  const navigate = useNavigate();

  return (
    <OrderSim
      breadCrumbs={
        <BreadCrumbsWithTitle
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            { name: t.AR0B(voiceSubscriptionsMsg), path: paths.PS_MOBILE_SUBSCRIPTIONS },
            {
              name: getSubscriptionBreadcrumbName(subscription),
              path:
                generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) +
                search,
            },
            { name: t.CVON(orderSimMsg) },
          ]}
        />
      }
      category={SubscriptionCategory.VOICE}
      companyInfo={companyInfo}
      disallowBillableSimChanges={false} // NOE is used by admins, always allow billable SIM changes.
      getServiceFeeSim={getServiceFeeSim}
      isEoe={false}
      onClickSubscription={() => {
        navigate(
          generatePath(paths.PS_MOBILE_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) }) + search
        );
      }}
      hasPendingActions={hasPendingActions}
      simTypeInitialSelection={SimType.ESIM}
      subscription={subscription!}
      user={authenticatedUser}
    />
  );
};
